<template>
  <v-app>
    <prb-toolbar v-bind:disable="!terms"></prb-toolbar>
    <prb-terms v-bind:termsDialog="!terms"></prb-terms>
    <main>
      <v-container fluid>
        <prb-loading v-if="loading"></prb-loading>
        <v-layout class="target__layout text-xs-center" v-if="!loading && errorPage" style="min-height:70vh;" align-center>
          <v-flex xs12 class="pa-5 white">
            <span class="title white">
              <b>
                <v-icon style="margin-bottom:3px;margin-right:3px;">error_outline</v-icon>
                Error: Data not found</b>
              </span>
          </v-flex>
        </v-layout>
        <v-layout class="target__layout" v-if="!loading && !errorPage">
          <v-flex xs12>
            <div class="target_layout__content elevation-1">
              <v-flex xs12 class="target__layout pa-0" v-if="titleName.length">
                <v-layout class="target-top__layout__summary-title">
                  <v-flex xs10 class="pa-0">
                    <div>{{titleName}} | Probes List</div>
                  </v-flex>
                  <v-flex xs2 class="pa-0" style="text-align:right;">
                    <v-btn icon class="white--text" v-tooltip:left="{ html: 'Download full compounds report' }" v-if="!loading" @click.native="downloadCsv(probes)">
                      <v-icon dark class="white--text">file_download</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-data-table id="all-table" v-if="probes" v-bind:headers="tableHeaders" v-bind:pagination.sync="pagination" :items="probes" v-bind:search="tableSearch" class="elevation-0">
                <template slot="headerCell" scope="props">
                  {{ props.header.text }}
                </template>
                <template slot="items" scope="props">
                    <tr>
                      <td><img :src="apiUrl + 'shared/ajax/get_compound_image.php?compound_id=' + props.item.id" height="100"/></td>
                      <td>{{ props.item.nameProbe }}</td>
                      <td>
                        <img v-for="(value, key) in tableFeatures"
                            :key="key"
                            height="25"
                            width="25"
                            :src="props.item[key] ? value.imageValid : value.imageInvalid"/>
                      </td>
                      <td>{{ props.item.global.toFixed(2) }}</td>
                      <td v-if="props.item.chemical_probes_portal_rating.length"><a :href="props.item.chemical_probes_portal_link" target="_blank">{{ props.item.chemical_probes_portal_rating }}</a></td>
                      <td v-if="!props.item.chemical_probes_portal_rating.length">-</td>
                    </tr>
                </template>
              </v-data-table>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </main>
    <prb-footer></prb-footer>
  </v-app>
</template>

<script>
import {
  mapGetters
} from 'vuex'

import PrbLoading from '././PrbLoading';
import PrbToolbar from './prb-toolbar/PrbToolbar';
import PrbTerms from './prb-terms/PrbTerms';
import PrbFooter from './prb-footer/PrbFooter';
import * as F from '../constants/Features';

export default {
  components: {
    PrbLoading,
    PrbToolbar,
    PrbTerms,
    PrbFooter
  },
  metaInfo() {
    return {
      title: this.titleName || ' ',
      titleTemplate: 'Probe Miner | %s | List Probes'
    }
  },
  computed: mapGetters([
    'termsVerified', 'loading'
  ]),
  name: 'prbcompoundsynopsis',
  computed: {
    terms: {
      get() {
        return this.$store.state.termsVerified
      }
    },
    loading: {
      get() {
        return this.$store.state.loading
      }
    }
  },
  beforeMount() {
    this.tableFeatures = F.FEATURES;
  },
  data() {
    return {
      apiUrl: process.env.API_URL,
      errorPage: false,
      probes: null,
      titleName: '',
      pagination: {
        rowsPerPage: 10
      },
      tableSearch: '',
      tableHeaders: [{
        text: 'Compound',
        align: 'left',
        sortable: false,
        value: 'image',
        tooltip: 'image'
        },{
          text: 'Name',
          align: 'left',
          sortable: true,
          value: 'nameProbe',
          tooltip: 'Name of target'
        },
        {
          text: 'Features',
          align: 'left',
          sortable: false,
          value: 'is_suitable_probe',
          tooltip: 'Toggle for more information about the icons'
        },
        {
          text: 'Global Score',
          align: 'left',
          sortable: true,
          value: 'global',
          tooltip: 'Global Score'
        },
        {
          text: 'ChemicalProbes.org Rating',
          align: 'left',
          sortable: true,
          value: 'chemical_probes_portal_rating',
          tooltip: 'Chemical Probes Portal Rating'
        }
      ]
    }
  },
  methods: {
    downloadCsv: function(data) {
      this.$store.dispatch("SET_LOADING");

      var JSONData = data;
      var ReportTitle = this.$route.params.id + '_ChemicalProbes';
      var ShowLabel = true;

      //If JSONData is not an object then JSON.parse will parse the JSON string in an Object
      var arrData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;

      var CSV = '';
      //Set Report title in first row or line

      CSV += ReportTitle + '\r\n\n';

      //This condition will generate the Label/Header
      if (ShowLabel) {
        var row = "";

        //This loop will extract the label from 1st index of on array
        for (var index in arrData[0]) {

          //Now convert each value to string and comma-seprated
          row += index + ',';
        }

        row = row.slice(0, -1);

        //append Label row with line break
        CSV += row + '\r\n';
      }

      //1st loop is to extract each row
      for (var i = 0; i < arrData.length; i++) {
        var row = "";

        //2nd loop will extract each column and convert it in string comma-seprated
        for (var index in arrData[i]) {
          row += '"' + arrData[i][index] + '",';
        }

        row.slice(0, row.length - 1);

        //add a line break after each row
        CSV += row + '\r\n';
      }

      if (CSV == '') {
        alert("Invalid data");
        return;
      }

      //Generate a file name
      var fileName = "Report_";
      //this will remove the blank-spaces from the title and replace it with an underscore
      fileName += ReportTitle.replace(/ /g, "_");

      //Initialize file format you want csv or xls
      var uri = 'data:text/csv;charset=utf-8,' + escape(CSV);

      // Now the little tricky part.
      // you can use either>> window.open(uri);
      // but this will not work in some browsers
      // or you will not get the correct file extension
      //
      // this trick will generate a temp <a /> tag
      var link = document.createElement("a");
      link.id = "copy-link";
      link.href = uri;
      // console.log(link);
      document.body.appendChild(link);
      //
      // //set the visibility hidden so it will not effect on your web-layout
      document.getElementById("copy-link").style.visibility = "hidden";
      // console.log(document.getElementById("copy-link"));
      document.getElementById("copy-link").download = fileName + ".csv";
      //
      // //this part will append the anchor tag and remove it after automatic click
      document.body.appendChild(link);
      document.getElementById("copy-link").click();
      // console.log(link);
      document.body.removeChild(link);

      this.$store.dispatch("UNSET_LOADING");
    }
  },
  name: 'prbcompoundsall',
  mounted() {
    let that = this;

    this.$store.dispatch("SET_LOADING");

    var reg = new RegExp('^\\d+$');

    that.$store.dispatch("GET_TARGET_PROBES_RESULTS_BY_ID", that.$route.params.id).then(function(res) {

      if (that.$store.state.probesResultsList) {
        let probes = that.$store.state.probesResultsList.metadata;

        that.titleName =  that.$store.state.probeGeneName;

        let s = [];

        Object.keys(probes).map(function(m, i){
          s.push(probes[m])
          s[i]['nameProbe'] = reg.test(probes[m].name) ? 'canSAR' +  probes[m].name : probes[m].name;
          s[i]['id'] = m;
          s[i]['chemical_probes_portal_rating'] = s[i].chemical_probes_portal !== undefined ?  parseFloat(s[i].chemical_probes_portal.rating_cell).toFixed(2) : '-';
          s[i]['chemical_probes_portal_link'] = s[i].chemical_probes_portal !== undefined ?  'http://www.chemicalprobes.org/' + s[i].name : null;
          delete s[i]['chemical_probes_portal'];
          delete s[i]['name'];
        })

        that.probes = s;
        that.$store.dispatch("UNSET_LOADING");
      } else {
        that.errorPage = true;
        that.$store.dispatch("UNSET_LOADING");
      }

    });

  },
  watch: {
    '$route' (to, from) {
      let that = this;

      that.errorPage =  false;

      this.$store.dispatch("SET_LOADING");

      var reg = new RegExp('^\\d+$');

      that.$store.dispatch("GET_TARGET_PROBES_RESULTS_BY_ID", that.$route.params.id).then(function(res) {

        if (that.$store.state.probesResultsList) {
          let probes = that.$store.state.probesResultsList.metadata;

          that.titleName =  that.$store.state.probeGeneName;

          let s = [];

          Object.keys(probes).map(function(m, i){
            s.push(probes[m])
            s[i]['nameProbe'] = reg.test(probes[m].name) ? 'canSAR' +  probes[m].name : probes[m].name;
            s[i]['id'] = m;
            s[i]['chemical_probes_portal_rating'] = s[i].chemical_probes_portal !== undefined ?  parseFloat(s[i].chemical_probes_portal.rating_cell).toFixed(2) : '';
            s[i]['chemical_probes_portal_link'] = s[i].chemical_probes_portal !== undefined ?  'http://www.chemicalprobes.org/' + s[i].name : null;
            delete s[i]['chemical_probes_portal'];
            delete s[i]['name'];
          })

          that.probes = s;
          that.$store.dispatch("UNSET_LOADING");
        } else {
          that.errorPage = true;
          that.$store.dispatch("UNSET_LOADING");
        }
      });
    }
  }
}

</script>

<style scoped>
.target-top__layout__summary-title{
  width: 100%;
  font-size: 30px;
  padding: 10px;
  font-weight: 300;
  background-color: #455A64;
  color: white;
  margin: 0 0 5px 0;
}
.target-probes__layout-title {
  width: 100%;
  font-size: 20px;
  padding: 10px;
  font-weight: 600;
  border-left: 5px solid #455A64;
  color: #455A64;
  background: rgba(0, 0, 0, .03);
}

.target__layout {
  height: 100%;
  background: url(../img/layer6.png) no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
.target_layout__content {
  margin: 5px 10px;
  background-color: #ffffff;
  border-radius: 2px;
}
.target_layout--loading {
  width:100%;
  text-align:center;
  padding:20%
}
.datatable__actions__select{
  display:none !important;
}
</style>

<style>
  #all-table .datatable__actions .datatable__actions__select{
    display: none !important;
  }
</style>



// WEBPACK FOOTER //
// PrbCompoundsAll.vue?ec8ebf86